import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AdminsService } from 'app/services/admins/admins.service';
import { AnnonceService } from 'app/annonce/annonce.service';
import { AdminRequestService, UserRequest } from 'app/services/adminrequest/adminrequest.service';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private toggleButton: any;
    private sidebarVisible: boolean;
    annonceNonVu: any;
    annonceCounter: any;
    
    // Admin request properties
    adminRequestCounter: number = 0;
    adminNotifications: UserRequest[] = [];
    showAdminDropdown: boolean = false;
    adminDropdownLoading: boolean = false;

    constructor(location: Location,
        private element: ElementRef,
        private router: Router,
        private authService: AdminsService,
        private serviceAnnonce: AnnonceService,
        private adminRequestService: AdminRequestService
    ) {
        this.location = location;
        this.sidebarVisible = false;
    }

    ngOnInit() {
        this.AnnouncementNonVu();
        this.loadAdminRequestCount();
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);

        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    
    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    };
    
    sidebarToggle() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];

        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
        const body = document.getElementsByClassName('navbar-toggler')[0];

        if (this.mobile_menu_visible == 1) {
            body.classList.remove('nav-open');
            if ($layer) {
                $layer.remove();
            }
            setTimeout(function () {
                $toggle.classList.remove('toggled');
            }, 400);

            this.mobile_menu_visible = 0;
        } else {
            setTimeout(function () {
                $toggle.classList.add('toggled');
            }, 430);

            var $layer = document.createElement('div');
            $layer.setAttribute('class', 'close-layer');

            if (body.querySelectorAll('.main-panel')) {
                document.getElementsByClassName('main-panel')[0].appendChild($layer);
            } else if (body.classList.contains('off-canvas-sidebar')) {
                document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
            }

            setTimeout(function () {
                $layer.classList.add('visible');
            }, 100);

            $layer.onclick = function () {
                body.classList.remove('nav-open');
                this.mobile_menu_visible = 0;
                $layer.classList.remove('visible');
                setTimeout(function () {
                    $layer.remove();
                    $toggle.classList.remove('toggled');
                }, 400);
            }.bind(this);

            body.classList.add('nav-open');
            this.mobile_menu_visible = 1;
        }
    };

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }

        for (var item = 0; item < this.listTitles?.length; item++) {
            if (this.listTitles[item].path === titlee) {
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }
    
    logout() {
        this.authService.logout();
        this.router.navigate(['login']);
    }

    AnnouncementNonVu() {
        interval(1200)
            .pipe(
                switchMap(() => this.serviceAnnonce.getAnnouncementNonVu())
            )
            .subscribe((data: any) => {
                this.annonceNonVu = data;
                this.annonceCounter = this.annonceNonVu?.length;
                console.log(this.annonceCounter);
            });
    }

    loadAdminRequestCount() {
        interval(5000)
            .pipe(
                switchMap(() => this.adminRequestService.getNotificationsCount())
            )
            .subscribe({
                next: (res: { count: number; message: string }) => {
                    this.adminRequestCounter = res.count;
                    console.log('Admin requests unread:', this.adminRequestCounter);
                },
                error: (err) => console.error('Failed to load admin request count', err)
            });
    }

    loadAdminNotifications() {
        if (this.adminDropdownLoading) return;
        this.adminDropdownLoading = true;
        console.log('Loading admin notifications...');
        
        this.adminRequestService.getNotifications().subscribe({
            next: (res) => {
                console.log('Admin notifications response:', res);
                // Check different possible response structures
                if (res && res.notifications) {
                    this.adminNotifications = res.notifications;
                } else if (Array.isArray(res)) {
                    this.adminNotifications = res;
                } else {
                    console.warn('Unexpected response structure:', res);
                    this.adminNotifications = [];
                }
                console.log('Parsed notifications:', this.adminNotifications);
                this.adminDropdownLoading = false;
            },
            error: (err) => {
                console.error('Failed to load admin notifications', err);
                this.adminDropdownLoading = false;
                this.adminNotifications = [];
            }
        });
    }

    toggleAdminDropdown(event: Event) {
        event.stopPropagation();
        if (!this.showAdminDropdown) {
            this.loadAdminNotifications();
        }
        this.showAdminDropdown = !this.showAdminDropdown;
    }

    closeAdminDropdown() {
        this.showAdminDropdown = false;
    }

    markAsRead(requestId: number, event: Event) {
        event.stopPropagation();
        this.adminRequestService.markAsRead(requestId).subscribe({
            next: () => {
                this.adminNotifications = this.adminNotifications.filter(n => n.id !== requestId);
                this.adminRequestCounter--;
                if (this.adminRequestCounter < 0) this.adminRequestCounter = 0;
            },
            error: (err) => console.error('Error marking as read', err)
        });
    }

    goToAdminRequests() {
        this.showAdminDropdown = false;
        this.router.navigate(['/admin-requests']);
    }

    viewRequestDetail(requestId: number) {
        this.showAdminDropdown = false;
        this.router.navigate(['/admin-requests', requestId]);
    }

    getRequestIcon(type: string): string {
        switch(type) {
            case 'PROJET': return 'business';
            case 'BIEN': return 'home';
            case 'SERVICE': return 'build';
            case 'PRODUIT': return 'shopping_cart';
            default: return 'assignment';
        }
    }

    getOperationLabel(operation: string): string {
        switch(operation) {
            case 'AJOUT': return '➕ Ajout';
            case 'MODIFICATION': return '✏️ Modification';
            case 'SUPPRESSION': return '🗑️ Suppression';
            default: return operation;
        }
    }
}